import React from "react";
import { MusicHallSettingContainerStyled } from "./styled";
import { connect } from "react-redux";
import { withRouter } from "navigations/withRouter";
import queryString from "query-string";
import { portalService } from "apiServices";
import { MdDelete } from "react-icons/md";
import moment from "moment";
import { toast } from "react-toastify";
import { AlertControl } from "components/Modals/Alert";
import { ROUTE_PATH } from "utils/constants/routePath";
import { Displays, Forms, Tables } from "components";

class MusicHallSettingContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    const query = this.buildQueryString();
    this.fetchData(query);
  }

  fetchData = async (query) => {
    let res = await portalService.GET_ROOM_AVAILABILITY_LIST(query);
    if (res && res.status === 200) {
      this.setState({
        data: res.data.docs,
        isLoading: false,
        isBgLoading: false,
      });
    }
  };

  // QUERY FLOW
  // =========================================
  // =========================================
  buildQueryString = (additionalParams = {}) => {
    const { router } = this.props;
    const urlParams = queryString.parse(router.location.search);
    const defaultQuery = {
      reason_closed: "1",
      pagination: false,
      // start_date: moment().startOf("month").format("YYYY-MM-DD"),
      // end_date: moment().endOf("month").format("YYYY-MM-DD"),
    };
    const finalParams = {
      ...defaultQuery,
      ...urlParams,
      ...additionalParams,
    };
    const cleanParams = Object.entries(finalParams)
      .filter(
        ([key, value]) => value !== null && value !== undefined && value !== ""
      )
      .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
    const query = `?${Object.entries(cleanParams)
      .map(([key, value]) => `${key}=${value}`)
      .join("&")}`;
    router.navigate(`${ROUTE_PATH.MUSIC_HALL_BOOKING_SETTING}${query}`);
    return query;
  };
  handleFilterKeyword = (e) => {
    const queryParams =
      typeof e === "string" ? queryString.parse(e.replace("?", "")) : e;
    this.handleJoinQuery(queryParams);
  };
  handlePageClick = (e) => {
    this.handleJoinQuery({ page: e.selected + 1 });
  };
  handleJoinQuery = (additionalQuery) => {
    const query = this.buildQueryString(additionalQuery);
    this.setState({
      isLoading: true,
    });
    this.fetchData(query);
  };

  handleClickDelete = async (e) => {
    AlertControl.show({
      title: "ยืนยันการลบ",
      description: "คุณต้องการจะลบใช่หรือไม่",
      btnLabel1: "ยกเลิก ",
      btnLabel2: "ยืนยัน",
      onEvent2: async () => {
        this.setState({
          isBgLoading: true,
        });
        let res = await portalService.DELETE_ROOM_AVAILABILITY_DETAIL(e);
        if (res && res.status === 200) {
          const query = this.buildQueryString();
          this.fetchData(query);
          toast.success("ลบสำเร็จ");
        } else {
          this.setState({
            isBgLoading: false,
          });
          toast.error("ลบไม่สำเร็จ");
        }
      },
    });
  };

  handleSubmit = async (values) => {
    this.setState({
      isBgLoading: true,
    });
    let params = {
      ...values,
      reason_closed: "1",
    };
    let res = await portalService.POST_ROOM_AVAILABILITY_DETAIL(params);
    if (res && res.status === 200) {
      this.setState(
        {
          isLoading: true,
        },
        () => {
          const query = this.buildQueryString();
          this.fetchData(query);
        }
      );
    } else {
      this.setState({
        isBgLoading: false,
      });
      AlertControl.show({
        title: "สร้างไม่สำเร็จ",
        description: "กรุณายกเลิกการจองของลูกค้า ในวันที่ต้องการสร้างวันหยุด",
        btnLabel2: "ตกลง",
      });
    }
  };

  render() {
    const { authenRedux } = this.props;
    const { isBgLoading, isLoading, data } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find(
          (e) => e.menu_key === "music-hall-booking"
        );
    return (
      <MusicHallSettingContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <div className="filter_layout"></div>
        {isLoading ? (
          <Displays.Loading theme_standard_loading />
        ) : (
          <>
            <Forms.RoomAvailabilityForm
              permission={permission}
              onSubmit={this.handleSubmit}
            />
            <div className="body_table">
              <Tables.Standard
                columns={columns({
                  handleClickDetail: this.handleClickCreate,
                  onClickDelete: this.handleClickDelete,
                })}
                data={data}
              />
            </div>
          </>
        )}
      </MusicHallSettingContainerStyled>
    );
  }
}

const columns = ({ onClickDelete }) => [
  {
    Header: <div style={{ textAlign: "left" }}>รายการวันหยุด</div>,
    accessor: "date",
    Cell: (props) =>
      moment(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY"),
  },
  {
    Header: <div style={{ textAlign: "left" }}></div>,
    accessor: "action",
    Cell: (props) => (
      <div onClick={() => onClickDelete(props.row.original._id)}>
        <MdDelete size={22} color="#4b1e78" />
      </div>
    ),
  },
];

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MusicHallSettingContainer));
